import { useRef } from 'react';

import Markdown from '../../common/Markdown/Markdown';
import NoTagRenderer from '../../common/NoTagRenderer/NoTagRenderer';
import { addBackground, convertToNewLine } from '../../core/helpers';
import useIntersection from '../../core/hooks/useIntersection';
import { IImage } from '../../core/models';
import './Commitment.css';

interface IProps {
  title: string;
  label?: string;
  img?: IImage;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const em = (props: any) => {
  const { children } = props;
  return <strong className="h1 accent">{convertToNewLine(children)}</strong>;
};

function Commitment({ title, label, img }: IProps) {
  const titleRef = useRef(null);
  const { isIntersecting } = useIntersection(titleRef, 0.5);

  return (
    <section className="commitment" {...addBackground({ img, gradient: 'blue3' })}>
      <div className="wrap wrap--lg">
        {!label ? null : <div className="commitment__label overline">{label}</div>}
        <h2 className={`commitment__title h1${isIntersecting ? ' visible' : ''}`} ref={titleRef}>
          <Markdown
            components={{
              p: NoTagRenderer,
              em,
            }}
          >
            {title}
          </Markdown>
        </h2>
      </div>
    </section>
  );
}

export default Commitment;
